import { memo } from 'react';
import * as S from './style';

interface IProps {
  children?: React.ReactNode;
}

const CategorySubmenuList = ({ children }: IProps) => (
  <S.CategorySubmenuList className="category-submenu-list">
    {children}
  </S.CategorySubmenuList>
);

export default memo(CategorySubmenuList);
